/* eslint-disable max-len */
import React, { FC } from 'react';

export const MyAccountHelpIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.7891 43.2C28.2686 43.2 29.468 41.9912 29.468 40.5C29.468 39.0088 28.2686 37.8 26.7891 37.8C25.3096 37.8 24.1102 39.0088 24.1102 40.5C24.1102 41.9912 25.3096 43.2 26.7891 43.2Z"
        fill="var(--primary-900)"
      />
      <path
        d="M26.7891 0C12.0173 0 0 12.1119 0 27C0 41.8881 12.0173 54 26.7891 54C41.5608 54 53.5781 41.8881 53.5781 27C53.5781 12.1119 41.5608 0 26.7891 0ZM26.7891 48.6C14.9721 48.6 5.35781 38.91 5.35781 27C5.35781 15.09 14.9721 5.4 26.7891 5.4C38.606 5.4 48.2203 15.09 48.2203 27C48.2203 38.91 38.606 48.6 26.7891 48.6Z"
        fill="var(--primary-900)"
      />
      <path
        d="M26.7891 10.8C20.8794 10.8 16.0734 15.6438 16.0734 21.6C16.0734 23.0905 17.2734 24.3 18.7523 24.3C20.2312 24.3 21.4312 23.0905 21.4312 21.6C21.4312 18.6219 23.8342 16.2 26.7891 16.2C29.7439 16.2 32.1469 18.6219 32.1469 21.6C32.1469 24.5781 29.7439 27 26.7891 27C25.3102 27 24.1101 28.2094 24.1101 29.7V32.4C24.1101 33.8905 25.3102 35.1 26.7891 35.1C28.268 35.1 29.468 33.8905 29.468 32.4V32.0572C34.0836 30.8555 37.5047 26.6218 37.5047 21.6C37.5047 15.6438 32.6987 10.8 26.7891 10.8Z"
        fill="var(--primary-900)"
      />
    </svg>
  );
};
